export const PATHWAYSUBPATHWAYLIST = "pathway-sub-pathway-list";
export const AGENCYSEARCH = "agency-search";
export const AGENCYDETAIL = "agency-detail";
export const AGENCYCUSTOMTABQUESTION = "agency-custom-tab-question";
export const AGENCYEMAILSEND = "agency-email-send";
export const CLAIMORG = "claim-org";
export const UPDATEORG = "update-org";
